import CountryContext from "CountryContext";
import {useContext, useState} from "react";
import useCountryAxiosInstance from "../../../hooks/useCountryAxiosInstance";
import useAsyncError from "../../../hooks/useAsyncError";

export const useColumnFilter = () => {

  // context
  const {country: {code}} = useContext(CountryContext);

  // hooks
  const api = useCountryAxiosInstance(code);
  const throwError = useAsyncError();

  // state
  const [loading, setLoading] = useState<Set<string>>(new Set());

  // handlers
  const fetch = (url: string, column: string, search: string, limit=20) => {
    setLoading((prev) => new Set(prev).add(column));
    try {
      const list = api!.get(url, {params: {column, search, limit}});
      return list as unknown as string[];
    }
    catch (error) {
      throwError(error);
      return null;
    }
    finally {
      setLoading((prev) => {
        const next = new Set(prev);
        next.delete(column);
        return next;
      });
    }
  }

  // utilities
  const isLoading = (column: string) => loading.has(column);

  return {fetch, isLoading};
}